import { generatePath, Navigate, useParams } from "react-router";

import { routes } from "~/routes";

/** A tenant's members now live on its detail page, so the old users address lands there. */
export function TenantUsersRedirect() {
  const { tenantId = "" } = useParams<{ tenantId: string }>();
  return <Navigate to={generatePath(routes.ConsoleTenant, { tenantId })} replace />;
}
